// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__K7Xi7","spinnerWrapper":"Loading_spinnerWrapper__IEEei","loadingText":"Loading_loadingText__3+pnw"};